import React from 'react';

const DemoMessage = ({ message }) => {
  const getMessageClass = () => {
    if (message.speaker === 'persona') return 'demo-message-persona';
    if (message.speaker === 'cerebral') return 'demo-message-cerebral';
    if (message.speaker === 'commentary') return 'demo-message-commentary';
    return 'demo-message';
  };

  return (
    <div className={`demo-message ${getMessageClass()}`}>
      {message.text}
    </div>
  );
};

export default DemoMessage;

